import { useEffect } from 'react';
import { useToast } from '@immo/ui-kit';
import { subscribeToToasts, type ToastTone } from '@/lib/toast';

const TONE_VARIANT = {
  success: 'success',
  error: 'danger',
  warning: 'warning',
} as const satisfies Record<ToastTone, 'success' | 'danger' | 'warning'>;

export function ToastBusBridge() {
  const toast = useToast();

  useEffect(() => {
    return subscribeToToasts((event) => {
      toast.show(TONE_VARIANT[event.tone], event.message);
    });
  }, [toast]);

  return null;
}
